module.exports = ['$scope', 'ngMeta', '$state', '$stateParams', 'bibContentManager', 'settings', '$notification', 'nodeHelper', function ($scope, ngMeta, $state, $stateParams, bibContentManager, settings, $notification, nodeHelper) {
  'use strict';
  let allParts;
  $scope.$state = {
    current: $state.current,
    href: $state.href
  };
  $scope.triggerScroll = false;
  $scope.loading = true;
  if($state.current.name === 'support.leerplansite') {
    $scope.$parent.breadcrumb = "LeerplanSite";
    $scope.$parent.title = "Wegwijs in de LeerplanSite";
    $scope.href = settings.support.leerplansite;
  } else if ($state.current.name === 'support.selectietool') {
    $scope.$parent.breadcrumb = "SelectieTool";
    $scope.$parent.title = "Wegwijs in de SelectieTool";
    $scope.href = settings.support.selectietool;
  }

  ngMeta.setTitle($scope.$parent.title);


  $scope.getSections = function (children) {
    if (children) {
      return children.filter(o => o.type === 'SECTION');
    } else {
      return [];
    }
  };

  $scope.checkScroll = function () {
    if ($scope.triggerScroll) {
      $scope.scrollTo($stateParams.hoofdstuk);
    }
  };

  bibContentManager.getContent($scope.href, ['SECTION', 'VIDEO', 'PARAGRAPH', 'IMAGE']).then(function(content){
    allParts = content;
    $scope.sections = $scope.getSections(allParts.contents);
    var firstSection = $scope.sections[0];

    if(!$stateParams.hoofdstuk) {
      $scope.viewItem = firstSection;
    } else {
      $scope.viewItem = nodeHelper.findRecursive(allParts.contents, $stateParams.hoofdstuk);
      if($scope.viewItem.parent.parent) {
        $scope.viewItem =  allParts.contents.find(o => o.key === $scope.viewItem.parent.key);
        $scope.triggerScroll = true;
      }
    }
    $scope.next = allParts.contents[allParts.contents.indexOf($scope.viewItem) + 1];
    $scope.prev = allParts.contents[allParts.contents.indexOf($scope.viewItem) - 1];
    $scope.loading = false;
  }).catch(function () {
    $notification.error("Probleem bij het laden van deze pagina.");
  });

  function elmYPosition(eID) {
    var elm = document.getElementById(eID);
    if(!elm){
      console.warn(eID + ' is not found');
    } else {
      var y = elm.offsetTop;
      var node = elm;
      while (node.offsetParent && node.offsetParent != document.body) {
        node = node.offsetParent;
        y += node.offsetTop;
      }
      return y;
    }
  }

  $scope.scrollTo = function (key) {
    window.scrollTo(0, elmYPosition(key) - 70 + 1);
  };

  $scope.scrollToTop = function () {
    window.scrollTo(0, 0);
  };

  $scope.$watch(function () {
    return $state.params.hoofdstuk;
  }, function (n, o) {
    if(o !== n) {
      if(!n) {
        $scope.viewItem = $scope.sections[0];
      } else {
        $scope.viewItem =  allParts.contents.filter(o => o.type === 'SECTION' && o.key === n)[0];
      }
      ngMeta.setTitle($scope.$parent.title + ': ' + $scope.viewItem.title);
      $scope.next = allParts.contents.filter(o => o.type === 'SECTION')[allParts.contents.filter(o => o.type === 'SECTION').indexOf($scope.viewItem) + 1];
      $scope.prev = allParts.contents.filter(o => o.type === 'SECTION')[allParts.contents.filter(o => o.type === 'SECTION').indexOf($scope.viewItem) - 1];
    }
  });




}];



// WEBPACK FOOTER //
// ./web/js/screen/support/supportViewController.js